const fr = {
  code: "fr",
  meta: {
    home: {
      title: "Bloom Beauty Concept Hair | Salon de coiffure à Venda do Pinheiro",
      desc: "Spécialiste des mèches, balayage, coloration, soins, alignement et lissage à Venda do Pinheiro. Réservez votre évaluation avec Monique Santos.",
    },
    sobre: {
      title: "À propos de Monique Santos | Bloom Beauty Concept Hair",
      desc: "Découvrez Monique Santos, la hairstylist derrière Bloom Beauty Concept Hair à Venda do Pinheiro. Accompagnement personnalisé et santé capillaire d'abord.",
    },
    servicos: {
      title: "Services | Bloom Beauty Concept Hair — Venda do Pinheiro",
      desc: "Coupes, coloration, mèches et balayage, correction de couleur, soins, programme capillaire, botox, alignement et lissage à Venda do Pinheiro.",
    },
    avaliacao: {
      title: "Évaluation Professionnelle | Bloom Beauty Concept Hair",
      desc: "Tout commence par une bonne évaluation : diagnostic du cheveu, historique chimique, test de mèche et plan personnalisé. Réservez via WhatsApp.",
    },
    transformacoes: {
      title: "Transformations | Bloom Beauty Concept Hair",
      desc: "Résultats réels en mèches, balayage, coloration, alignement et lissage chez Bloom Beauty Concept Hair, Venda do Pinheiro.",
    },
    galeria: {
      title: "Galerie | Bloom Beauty Concept Hair",
      desc: "L'espace, les détails et le travail de Bloom Beauty Concept Hair à Venda do Pinheiro.",
    },
    contato: {
      title: "Contact | Bloom Beauty Concept Hair — Venda do Pinheiro",
      desc: "Rua Casal dos Ninhos 1B, Venda do Pinheiro. WhatsApp +351 963 085 891. Lun–Ven 09:00–19:00, sam 09:30–18:00.",
    },
    privacidade: {
      title: "Politique de Confidentialité | Bloom Beauty Concept Hair",
      desc: "Politique de confidentialité et de protection des données de Bloom Beauty Concept Hair.",
    },
  },
  nav: {
    home: "Accueil", about: "À propos", services: "Services", transformations: "Transformations",
    gallery: "Galerie", contact: "Contact", book: "Réserver une évaluation", menu: "Menu", close: "Fermer",
  },
  common: {
    learnMore: "En savoir plus", bookEval: "Réserver une évaluation", bookService: "Prendre rendez-vous",
    whatsapp: "WhatsApp", instagram: "Instagram", directions: "Itinéraire", call: "Appeler",
    send: "Envoyer la demande", sending: "Envoi…", viewServices: "Découvrir les services",
    seeTransformations: "Voir les transformations", seeGallery: "Voir la galerie", all: "Tous",
    backToServices: "Retour aux services",
    includedNote: "Pas de prix en ligne : chaque cheveu est unique. Les tarifs sont indiqués après évaluation ou via WhatsApp.",
    soonGoogle: "Bientôt disponible — nous préparons notre profil Google.",
  },
  home: {
    heroEyebrow: "Bloom Beauty Concept Hair — Venda do Pinheiro",
    heroLines: ["Des cheveux qui révèlent", "votre plus belle", "version."],
    heroText: "Spécialiste de la couleur, de l'illumination, des soins, de l'alignement et de la transformation capillaire à Venda do Pinheiro.",
    ctaPrimary: "Réserver une évaluation",
    ctaSecondary: "Découvrir les services",
    scroll: "Faites défiler pour découvrir",
    marquee: ["Mèches & Balayage", "Coloration", "Soins Capillaires", "Alignement", "Lissage", "Coupe & Finition"],
    welcome: {
      eyebrow: "Bienvenue chez Bloom",
      title: "Un concept de beauté sur mesure",
      p: "Bloom Beauty Concept Hair est né pour offrir une expérience de beauté personnalisée, où chaque cheveu est évalué individuellement et où chaque transformation respecte l'identité, la santé de la fibre et le désir de chaque cliente.",
      tag: "Nous révélons votre beauté, nous révélons votre essence.",
    },
    specialties: {
      eyebrow: "Spécialités",
      title: "Ce que nous pouvons faire pour vos cheveux",
      sub: "Techniques personnalisées, produits professionnels et un regard attentif à la santé de la fibre.",
    },
    monique: {
      eyebrow: "La Hairstylist",
      title: "Découvrez Monique Santos",
      p1: "Derrière Bloom se trouve Monique Santos, hairstylist passionnée par la mise en valeur de la beauté et de l'identité de chaque femme.",
      p2: "Chaque rendez-vous commence par une analyse attentive du cheveu, de son historique chimique, des objectifs de la cliente et de la santé de la fibre. L'objectif n'est pas seulement de transformer le look, mais de créer des résultats beaux, personnalisés et durables.",
      cta: "Découvrir Monique",
    },
    transformations: {
      eyebrow: "Portfolio",
      title: "Des transformations qui parlent d'elles-mêmes.",
      p: "Chaque cheveu a une histoire. Chaque résultat est construit de façon personnalisée.",
    },
    experience: {
      eyebrow: "L'Expérience Bloom",
      title: "Chaque détail, pensé pour vous",
      steps: [
        { n: "01", t: "Évaluation individuelle", d: "Avant toute technique, nous écoutons votre histoire et analysons vos cheveux." },
        { n: "02", t: "Technique personnalisée", d: "Chaque service est adapté à votre fibre, à votre visage et à votre style de vie." },
        { n: "03", t: "Produits professionnels", d: "Nous travaillons avec des gammes professionnelles choisies pour chaque besoin." },
        { n: "04", t: "Soin de la santé du cheveu", d: "Une beauté durable n'existe qu'avec une fibre saine — toujours." },
      ],
    },
    evaluation: {
      eyebrow: "Évaluation Professionnelle",
      title: "Tout commence par une bonne évaluation.",
      p: "Certaines procédures exigent une analyse professionnelle avant toute transformation. C'est ainsi que nous protégeons la santé de vos cheveux et garantissons le résultat qui vous convient.",
      items: [
        "Diagnostic du cheveu", "Analyse du cuir chevelu", "Historique chimique", "Objectif de la cliente",
        "Plan personnalisé", "Test de mèche si nécessaire", "Estimation du temps", "Conseil professionnel",
      ],
      cta: "Réserver mon évaluation",
    },
    salon: {
      eyebrow: "Le Salon",
      title: "Un espace créé pour prendre soin de vous.",
      p: "Un cadre chaleureux et élégant où chaque détail a été pensé pour transformer votre moment de beauté en une expérience spéciale.",
    },
    quote: "Prendre soin de ses cheveux, c'est plus que de l'esthétique. C'est de l'estime de soi, c'est se souvenir de soi.",
    final: {
      title: "Prête à vivre l'expérience Bloom ?",
      p: "Parlez directement avec Monique et réservez votre évaluation.",
      cta: "Réserver via WhatsApp",
    },
    quotes: [
      "Prenez soin de vous avec la même tendresse que vous offrez aux autres.",
      "Votre beauté commence lorsque vous reconnaissez votre propre valeur.",
      "Une nouvelle chevelure peut être le début d'une nouvelle énergie.",
      "Réservez-vous un moment. Vous le méritez.",
      "Révélez votre beauté. Révélez votre essence.",
      "Quand on se sent bien avec soi-même, cela se voit à l'extérieur.",
      "Épanouissez-vous dans votre propre beauté.",
    ],
  },
  about: {
    eyebrow: "À propos",
    title: "Plus que des cheveux. Une expérience de soin.",
    p1: "Derrière Bloom Beauty Concept Hair se trouve Monique Santos, hairstylist passionnée par la mise en valeur de la beauté et de l'identité de chaque femme qui s'assoit dans son fauteuil.",
    p2: "Chaque rendez-vous commence par une analyse attentive du cheveu, de son historique chimique, des objectifs de la cliente et de la santé de la fibre. L'objectif n'est pas seulement de transformer le look, mais de créer des résultats beaux, personnalisés et durables — qui ont du sens au quotidien.",
    p3: "Chez Bloom, nous croyons que la vraie transformation commence lorsque chaque femme se choisit, prend soin d'elle et s'honore. Ici, chaque détail est pensé pour révéler qui vous êtes déjà.",
    philosophyTitle: "Ma philosophie",
    philosophy: "Chaque femme possède une beauté unique. Mon travail consiste à comprendre son style, ses cheveux et le résultat qu'elle souhaite atteindre, pour créer une transformation qui respecte son identité.",
    valuesTitle: "Ce que vous pouvez attendre",
    values: [
      { t: "Une écoute sincère", d: "Vos envies et votre routine sont le point de départ de chaque proposition." },
      { t: "La santé capillaire d'abord", d: "Aucune transformation ne vaut la santé de vos cheveux." },
      { t: "Une mise à jour constante", d: "Techniques et produits en évolution, au service de vos cheveux." },
      { t: "La transparence", d: "Une évaluation honnête, sans promesses impossibles." },
    ],
    coursesEyebrow: "Formation professionnelle",
    coursesTitle: "Monique Santos est également formatrice",
    coursesText: "En plus des prestations au salon, Monique donne également des formations professionnelles en soins capillaires et lissage.",
    courseHairTreatments: "Formation Soins Capillaires",
    courseStraightening: "Formation Lissage",
    lorenaEyebrow: "Professionnelle Bloom",
    lorenaTitle: "Découvrez Lorena",
    lorenaText: "Lorena fait partie de l'équipe Bloom et est formée professionnellement à l'épilation laser et au nettoyage du visage, avec une prise en charge attentive et personnalisée.",
    lorenaLaser: "Épilation Laser",
    lorenaSkin: "Nettoyage du Visage",
    cta: "Parler à Monique",
    quote: "Votre beauté s'épanouit.",
  },
  servicesPage: {
    eyebrow: "Services",
    title: "Un menu de soins pour chaque chevelure",
    sub: "Explorez chaque spécialité. Chaque service commence par l'écoute et, si nécessaire, une évaluation professionnelle — c'est pourquoi nous n'affichons pas de prix en ligne.",
  },
  services: {
    "cortes-finalizacao": {
      name: "Coupes & Finition",
      short: "Coupes et coiffages qui respectent votre visage et le mouvement naturel du cheveu.",
      desc: "Coupes et finitions pensées pour valoriser la forme du visage, le mouvement du cheveu et le style de chaque cliente.",
      items: [
        "Coupe femme", "Coupe + séchage", "Coupe + brushing", "Coupe homme",
        "Frange / ajustement de coupe", "Séchage simple", "Brushing — cheveux courts",
        "Brushing — cheveux mi-longs", "Brushing — cheveux longs",
        "Brushing — cheveux extra longs ou denses", "Fer à lisser / finition lisse", "Ondulations / coiffage",
      ],
      cta: "Prendre rendez-vous",
    },
    coloracao: {
      name: "Coloration",
      short: "Des couleurs personnalisées qui valorisent la peau, le style et l'identité.",
      desc: "Des couleurs développées de façon personnalisée pour valoriser la peau, le style et l'identité de chaque cliente.",
      note: "Certains services peuvent nécessiter une évaluation préalable.",
      items: [
        "Coloration des racines", "Coloration complète — cheveux courts", "Coloration complète — cheveux mi-longs",
        "Coloration complète — cheveux longs", "Coloration — cheveux extra longs ou denses",
        "Tonalisation / Gloss", "Bain de brillance", "Couverture des cheveux blancs", "Coloration + coupe + brushing",
      ],
      cta: "Prendre rendez-vous",
    },
    "mechas-balayage": {
      name: "Illuminations, Mèches & Balayage",
      short: "Une illumination sur mesure : du babylight subtil au blond intégral.",
      desc: "Des illuminations créées selon la coupe, le teint, la base naturelle du cheveu et l'objectif de la cliente.",
      note: "Les transformations de couleur peuvent exiger une évaluation et un test de mèche.",
      items: [
        "Mèches partielles", "Mèches complètes", "Balayage", "Balayage Premium",
        "Contour / Face Framing", "Illumination partielle", "Blond intégral", "Babylights",
        "Mèches + tonalisation + brushing",
      ],
      cta: "Réserver une évaluation",
    },
    "correcao-de-cor": {
      name: "Correction de Couleur",
      short: "Récupérer, rééquilibrer et reconstruire la couleur en sécurité.",
      desc: "Corriger une couleur est un processus technique qui exige diagnostic, stratégie et respect de la fibre capillaire. Chaque cas est étudié individuellement.",
      note: "Les services complexes de correction doivent être évalués individuellement.",
      items: [
        "Correction de couleur simple", "Correction de couleur moyenne", "Correction de couleur complexe",
        "Décoloration globale", "Élimination de pigments", "Transformation de couleur", "Correction + reconstruction",
      ],
      cta: "Réserver une évaluation",
    },
    "tratamentos-capilares": {
      name: "Soins Capillaires",
      short: "Hydratation, nutrition et reconstruction pour des cheveux visiblement sains.",
      desc: "Des rituels de soin choisis selon les besoins réels de vos cheveux — car aucune fibre ne ressemble à une autre.",
      items: [
        "Hydratation", "Nutrition", "Reconstruction", "Soin anti-frisottis", "Détox capillaire",
        "Cautérisation", "Reconstruction intensive", "Soin premium", "Soin + brushing",
      ],
      highlights: [
        { t: "Hydratation", d: "Apport en eau pour des fibres souples et flexibles." },
        { t: "Nutrition", d: "Apport en lipides pour brillance et discipline." },
        { t: "Reconstruction", d: "Apport en masse et protéines pour force et structure." },
      ],
      cta: "Prendre rendez-vous",
    },
    "cronograma-capilar": {
      name: "Programme Capillaire",
      short: "Un plan de séances pensé pour la récupération de vos cheveux.",
      desc: "Un programme de soins séquentiel qui combine hydratation, nutrition et reconstruction dans la mesure exacte de votre fibre.",
      items: ["Programme de 3 séances", "Programme de 4 séances", "Programme Premium", "Séance individuelle"],
      process: ["Évaluation", "Diagnostic", "Plan personnalisé", "Séances", "Entretien"],
      cta: "Réserver une évaluation",
    },
    "botox-alinhamento": {
      name: "Botox & Alignement",
      short: "Des fibres alignées, brillantes et sans frisottis — avec la technologie Bloom.",
      desc: "Du botox capillaire au Réalignement Bloom : des technologies d'alignement qui redonnent discipline, brillance et douceur, dans le respect de la santé du cheveu.",
      note: "Les options varient selon la longueur et la densité du cheveu — définies lors de l'évaluation.",
      items: ["Botox capillaire", "Botox Premium", "Scellage", "Alignement", "Soin anti-frisottis"],
      cta: "Réserver une évaluation",
    },
    "progressiva-alisamentos": {
      name: "Lissage Progressif & Lissages",
      short: "Un lisse naturel, avec du mouvement et sans frisottis, chaque jour.",
      desc: "Des cheveux alignés, brillants, doux et sans frisottis, chaque jour. La bonne technique — lissage progressif, organique ou premium — est choisie après évaluation de la fibre.",
      note: "Services séparés par longueur et densité — tarifs uniquement après évaluation.",
      items: ["Lissage progressif", "Lissage organique", "Lissage Premium", "Réalignement Bloom"],
      cta: "Réserver une évaluation",
    },
    "depilacao-a-laser": {
      name: "Épilation Laser",
      short: "Séances d'épilation laser réalisées par Lorena.",
      desc: "Un service personnalisé pour celles et ceux qui recherchent une réduction progressive des poils avec un suivi professionnel.",
      professional: "Avec Lorena",
      note: "Le protocole et la fréquence des séances sont définis individuellement après évaluation.",
      items: ["Évaluation initiale", "Plan de séances personnalisé", "Épilation laser par zones", "Suivi entre les séances"],
      cta: "Réserver avec Lorena",
      waMessage: "Bonjour ! J'ai vu le site de Bloom et je souhaiterais des informations ou réserver une épilation laser avec Lorena.",
    },
    "limpeza-de-pele": {
      name: "Nettoyage du Visage",
      short: "Soin du visage personnalisé réalisé par Lorena.",
      desc: "Une expérience de soin du visage axée sur le nettoyage, la préparation et le confort de la peau, adaptée aux besoins de chaque cliente.",
      professional: "Avec Lorena",
      items: ["Évaluation de la peau", "Nettoyage", "Nettoyage et soin du visage", "Masque visage", "Finition et conseils de soin"],
      cta: "Réserver avec Lorena",
      waMessage: "Bonjour ! J'ai vu le site de Bloom et je souhaiterais des informations ou réserver un nettoyage du visage avec Lorena.",
    },
    avaliacao: {
      name: "Évaluation Professionnelle",
      short: "Le point de départ de toute transformation en sécurité.",
      desc: "Diagnostic complet du cheveu et du cuir chevelu, avec test de mèche inclus si nécessaire.",
    },
  },
  avaliacaoPage: {
    eyebrow: "Évaluation Professionnelle",
    title: "Tout commence par une bonne évaluation.",
    p: "Avant toute transformation de couleur, lissage ou soin intensif, nous analysons vos cheveux en détail. C'est cette attention qui rend les résultats beaux, sûrs et durables.",
    itemsTitle: "Ce que nous analysons",
    items: [
      { t: "Condition de la fibre", d: "Élasticité, porosité, force et niveau de dommage." },
      { t: "Cuir chevelu", d: "Observation de l'état général du cuir chevelu." },
      { t: "Historique chimique", d: "Colorations, décolorations et lissages antérieurs." },
      { t: "Objectif de la cliente", d: "Le résultat souhaité et ce qui est réalisable." },
      { t: "Technique et étapes", d: "Définition de la technique, du temps et des phases possibles." },
      { t: "Test de mèche", d: "Chaque fois que nécessaire, avant les procédures chimiques." },
      { t: "Entretien", d: "Conseils pour entretenir le résultat à la maison." },
    ],
    cta: "Réserver une évaluation via WhatsApp",
  },
  transformationsPage: {
    eyebrow: "Transformations",
    title: "Des transformations qui parlent d'elles-mêmes.",
    p: "Des résultats réels, construits de façon personnalisée. Chaque cheveu a une histoire — en voici quelques-unes.",
    filters: { all: "Toutes", antesDepois: "Avant & Après", coloracao: "Coloration", balayage: "Balayage", progressiva: "Lissage", cortes: "Coupes" },
    slider: { before: "Avant", after: "Après" },
    captions: {
      balayage: "Balayage",
      progressiva: "Lissage Progressif Bio",
      corteBob: "Carré Court Plongeant",
      colocacao: "Extensions",
      loiro: "Blond",
      ruiva: "Coloration Cuivrée",
      videoLoiro: "Blond — sans filtre",
      videoProg: "Lissage Progressif Bio",
      videoRuiva: "Coloration Cuivrée",
      moniquePro: "Monique Santos — Bloom Beauty Concept Hair",
    },
  },
  galleryPage: {
    eyebrow: "Galerie",
    title: "L'univers Bloom en images",
    p: "L'espace, les détails, les réalisations et l'essence de Bloom Beauty Concept Hair.",
    tags: { all: "Tout", coloracao: "Coloration", balayage: "Balayage", progressiva: "Lissage", cortes: "Coupes" },
    captions: {
      balayage: "Balayage",
      progressiva: "Lissage Progressif Bio",
      corteBob: "Carré Court Plongeant",
      colocacao: "Extensions",
      loiro: "Blond",
      ruiva: "Coloration Cuivrée",
      videoLoiro: "Blond — sans filtre",
      videoProg: "Lissage Progressif Bio",
      videoRuiva: "Coloration Cuivrée",
      moniquePro: "Monique Santos — Bloom Beauty Concept Hair",
    },
  },
  contactPage: {
    eyebrow: "Contact",
    title: "Parlons de vos cheveux ?",
    p: "Nous sommes à Venda do Pinheiro, portes ouvertes pour vous. Écrivez-nous via WhatsApp, Instagram ou le formulaire.",
    addressTitle: "Adresse",
    phoneTitle: "Téléphone / WhatsApp",
    hoursTitle: "Horaires",
    hoursWeek: "Lundi à vendredi",
    hoursWeekTime: "09h00 – 19h00",
    hoursSat: "Samedi",
    hoursSatTime: "09h30 – 18h00",
    formTitle: "Envoyer une demande",
    form: {
      name: "Nom", namePh: "Votre nom",
      phone: "Téléphone", phonePh: "+351 …",
      email: "Email", emailPh: "votreemail@exemple.com",
      service: "Service souhaité",
      message: "Message", messagePh: "Dites-nous ce que vous cherchez…",
      submit: "Envoyer la demande",
      success: "Demande envoyée ! Nous répondrons au plus vite. Si vous préférez, écrivez-nous tout de suite sur WhatsApp.",
      error: "Envoi impossible. Réessayez ou écrivez-nous sur WhatsApp.",
      required: "Veuillez remplir votre nom et votre message.",
    },
    serviceOptions: ["Coupe", "Coloration", "Mèches", "Balayage", "Correction de Couleur", "Soin", "Programme", "Botox", "Alignement", "Lissage", "Évaluation", "Autre"],
    whatsappCta: "Discuter sur WhatsApp",
    googleCta: "Évaluez-nous sur Google",
    googleTitle: "Bloom sur Google",
    googleRating: "★★★★★ 5,0 · 2 avis",
    googleNote: "Consultez les avis réels sur notre profil officiel ou laissez le vôtre.",
    viewReviews: "Voir les avis",
    leaveReview: "Laisser un avis ⭐",
  },
  assistant: {
    name: "Assistante Bloom",
    status: "En ligne",
    greeting: "Bonjour ! 🌸 Bienvenue chez Bloom Beauty Concept Hair. Comment puis-je vous aider ?",
    placeholder: "Écrivez votre message…",
    whatsapp: "Parler à Monique sur WhatsApp",
    options: [
      { id: "eval", label: "Je veux réserver une évaluation" },
      { id: "services", label: "Je veux découvrir les services" },
      { id: "mechas", label: "J'ai des questions sur les mèches" },
      { id: "progressiva", label: "Je veux en savoir plus sur le lissage" },
      { id: "treatments", label: "Je veux en savoir plus sur les soins" },
      { id: "location", label: "Où se trouve le salon ?" },
      { id: "hours", label: "Quels sont les horaires ?" },
    ],
    answers: {
      eval: "Avec grand plaisir ! L'évaluation professionnelle est la première étape : nous analysons la condition de la fibre, le cuir chevelu, l'historique chimique et votre objectif — avec un test de mèche si nécessaire. Puis-je vous mettre en contact avec Monique sur WhatsApp pour réserver ?",
      services: "Nous proposons Coupes & Finition, Coloration, Illuminations, Mèches & Balayage, Correction de Couleur, Soins Capillaires, Programme Capillaire, Botox & Alignement et Lissage. Explorez chaque spécialité sur la page Services.",
      mechas: "Les illuminations et mèches sont créées selon votre coupe, votre teint, votre base naturelle et votre objectif. Les transformations de couleur peuvent exiger une évaluation et un test de mèche — c'est ainsi que nous garantissons un résultat beau et sain.",
      progressiva: "Le lissage laisse les cheveux alignés, brillants et sans frisottis. La technique idéale dépend de la longueur, de la densité et de la condition de la fibre — c'est pourquoi tout commence par une évaluation.",
      treatments: "Nous proposons hydratation, nutrition, reconstruction, détox capillaire, cautérisation et soins premium. Lors de l'évaluation, nous identifions exactement ce dont vos cheveux ont besoin — eau, lipides ou protéines.",
      location: "Nous sommes au Rua Casal dos Ninhos 1B, Venda do Pinheiro, 2665-536. Sur la page Contact, vous trouverez le bouton « Itinéraire ».",
      hours: "Lundi à vendredi : 09h00–19h00. Samedi : 09h30–18h00. Dimanche : fermé.",
      price: "Les tarifs varient selon le service, la longueur, la densité et la condition du cheveu — c'est pourquoi nous ne publions pas de prix. Monique vous dira tout avec plaisir, sur WhatsApp ou lors d'une évaluation.",
      fallback: "Pour vous répondre avec toute l'attention nécessaire, le mieux est de parler directement avec Monique. Puis-je vous transférer vers WhatsApp ?",
    },
    keywords: {
      eval: ["réserver", "reserver", "rendez-vous", "rdv", "évaluation", "evaluation", "prendre"],
      price: ["prix", "tarif", "coût", "cout", "combien", "cher"],
      hours: ["horaire", "horaires", "ouvert", "fermé", "ferme", "samedi", "dimanche", "quand"],
      location: ["où", "ou", "adresse", "situé", "situe", "itinéraire", "itineraire", "venir"],
      mechas: ["mèche", "meche", "balayage", "blond", "illumination", "babylight"],
      progressiva: ["lissage", "progressif", "lisse", "lisser"],
      treatments: ["soin", "hydratation", "nutrition", "reconstruction", "botox", "programme", "frisottis", "détox", "detox"],
      services: ["service", "services", "coupe", "coloration", "couleur"],
    },
  },
  footer: {
    tagline: "Nous révélons votre beauté, nous révélons votre essence.",
    nav: "Navigation", contact: "Contact", follow: "Suivez-nous",
    hours: "Lun–Ven 09h00–19h00 · Sam 09h30–18h00",
    rights: "Tous droits réservés.",
    privacy: "Politique de Confidentialité",
  },
  privacyPage: {
    title: "Politique de Confidentialité",
    updated: "Dernière mise à jour : septembre 2026",
    sections: [
      { t: "Données collectées", d: "Lorsque vous nous contactez via le formulaire ou WhatsApp, nous collectons votre nom, téléphone, email et votre message, uniquement pour répondre à votre demande et gérer les rendez-vous." },
      { t: "Comment nous les utilisons", d: "Les données sont utilisées exclusivement pour communiquer avec vous au sujet de nos services. Nous ne vendons ni ne partageons vos données avec des tiers à des fins marketing." },
      { t: "Conservation", d: "Les données sont conservées uniquement le temps nécessaire au traitement de votre demande et à la relation client." },
      { t: "Vos droits", d: "Vous pouvez demander l'accès, la rectification ou la suppression de vos données à tout moment, en appelant le +351 963 085 891 ou via Instagram @monique_santoshairstylist." },
      { t: "Cookies", d: "Ce site n'utilise que des outils d'analyse anonymes pour améliorer l'expérience de navigation." },
    ],
  },
  notFound: { title: "Page introuvable", p: "L'adresse recherchée n'existe pas ou a été déplacée.", cta: "Retour à l'accueil" },
  waDefault: "Bonjour Monique ! J'ai vu le site de Bloom Beauty Concept Hair et j'aimerais des informations / réserver une évaluation.",
  waEval: "Bonjour Monique ! J'ai vu le site de Bloom et j'aimerais réserver une évaluation professionnelle.",
};

export default fr;
